import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { Button } from 'ncoded-component-library';
import { useState } from 'react';
import useCampaignSettings from 'hooks/useCampaignSettings';
import { API_PATHS } from 'api';
import { BlockUI, CampaignModal } from 'components';
import { useAuth, useTanstackMutation } from 'hooks';
import NcodedLogoIcon from 'icons/FanOutLogo.icon';
import { FiPlus, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { LeadsGlobalSearch } from './components';

import './Header.styles.scss';
import classNames from 'classnames';

const Header = () => {
  const [createCampaignModalOpen, setCreateCampaignModalOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  const { data: campaignSettings } = useCampaignSettings();

  const { user, isLoading, removeCredentials } = useAuth();

  const { mutate: mutateLogout } = useTanstackMutation({
    onSuccess: () => {
      removeCredentials();
    },
    onError: () => {
      toast.error('Failed to log out. Please try again.');
    },
  });

  const navClasses = classNames('header__nav', {
    'header__nav--closed': !navOpen,
  });

  return (
    <header className="header">
      <NcodedLogoIcon />
      <nav className={navClasses}>
        <Button
          variant="icon"
          className="header__close-menu-btn"
          onClick={() => setNavOpen(false)}
        >
          <FiX />
        </Button>

        {user ? (
          <div className="header__left-section">
            <Link to="/settings" onClick={() => setNavOpen(false)}>
              Settings
            </Link>
            <Link to="/campaigns" onClick={() => setNavOpen(false)}>
              Campaigns
            </Link>
            <Button
              className="header__create-btn"
              onClick={() => {
                setCreateCampaignModalOpen(true);
                setNavOpen(false);
              }}
            >
              <FiPlus /> Create Campaign
            </Button>
            <LeadsGlobalSearch />
          </div>
        ) : (
          <div />
        )}

        <div className="header__right-section">
          <BlockUI loading={isLoading} />
          {user ? (
            <>
              <Link to="/profile" onClick={() => setNavOpen(false)}>
                {user.firstName} {user.lastName}
              </Link>
              <Button
                variant="icon"
                className="header__logout-btn"
                onClick={() => {
                  mutateLogout({
                    path: API_PATHS.auth.logout(),
                    method: 'post',
                  });
                  setNavOpen(false);
                }}
              >
                <FiLogOut />
                Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
            </>
          )}
        </div>
      </nav>
      <Button
        variant="icon"
        onClick={() => setNavOpen(!navOpen)}
        className="header__menu-btn"
      >
        <FiMenu />
      </Button>
      {createCampaignModalOpen && (
        <CampaignModal
          isOpen={createCampaignModalOpen}
          onClose={() => setCreateCampaignModalOpen(false)}
          mode="create"
          initialValues={campaignSettings || {}}
        />
      )}
    </header>
  );
};

export default Header;
